import { type FC } from 'react';
import { type User } from '@/api/admin/user';
import { UiHStack, UiStack, uiStyles, UiText, UiSimpleGrid } from '@/lib/ui';
import { Avatar } from '@chakra-ui/react';
import dayjs from 'dayjs';

export interface UserSummaryProps {
  user: User
}

const UserSummary: FC<UserSummaryProps> = ({ user }) => {
  const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'No name';
  
  return (
    <UiStack
      p={8}
      py={6}
      bgColor={'#fff'}
      shadow={uiStyles.cardShadow}
      borderRadius={uiStyles.borderRadius}
      spacing={6}
    >
      <UiHStack spacing={8} alignItems="flex-start">
        <Avatar 
          size={'xl'} 
          name={fullName}
          src={user.avatar || user.profile || undefined}
        />
        
        <UiStack flex={1}>
          <UiSimpleGrid columns={4} gap={8}>
            <UiStack>
              <UiText color={'text.secondary'}>Name</UiText>
              <UiText>{fullName}</UiText>
            </UiStack>
            
            <UiStack>
              <UiText color={'text.secondary'}>Email</UiText>
              <UiText>{user.email}</UiText>
            </UiStack>
            
            <UiStack>
              <UiText color={'text.secondary'}>User ID</UiText>
              <UiText>{user.id}</UiText>
            </UiStack>
            
            <UiStack>
              <UiText color={'text.secondary'}>Membership ID</UiText>
              <UiText>{user.clientId || 'N/A'}</UiText>
            </UiStack>
            
            <UiStack>
              <UiText color={'text.secondary'}>Last Sign In</UiText>
              <UiText>{user.lastSignInAt ? dayjs(user.lastSignInAt).format('Do MMMM YYYY HH:mm') : 'Never'}</UiText>
            </UiStack>
            
            <UiStack>
              <UiText color={'text.secondary'}>Created</UiText>
              <UiText>{dayjs(user.createdAt).format('Do MMMM YYYY')}</UiText>
            </UiStack>
            
            <UiStack>
              <UiText color={'text.secondary'}>Updated</UiText>
              <UiText>{dayjs(user.updatedAt).format('Do MMMM YYYY')}</UiText>
            </UiStack>
          </UiSimpleGrid>
        </UiStack>
      </UiHStack>
      
      {user.bio && (
        <UiStack>
          <UiText color={'text.secondary'}>Bio</UiText>
          <div 
            style={{ fontSize: '14px', lineHeight: '1.5', color: '#2D3748' }}
            dangerouslySetInnerHTML={{ __html: user.bio }}
          />
        </UiStack>
      )}
    </UiStack>
  );
};

export default UserSummary;